import { Button, Center } from "@mantine/core";
import React from "react";
import DaumPostcode from "react-daum-postcode";
import styled from "styled-components";

const Post = ({ onComplete, onCancel }) => {
  const handleComplete = (data) => {
    onComplete(data);
  };

  return (
    <S.PostModal>
      <DaumPostcode onComplete={handleComplete} />
      <Center onClick={onCancel}>
        <Button> 닫기 </Button>
      </Center>
    </S.PostModal>
  );
};

export default Post;

const S = {
  PostModal: styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    height: 430px;
    background-color: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    z-index: 2000;
  `,
};
